import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export type UpdateLinkedTasksParams = {
  readonly ids: string[]; // LinkedTaskIds
  readonly scheduleId: string;
}

export class UpdateLinkedTasksScheduleRequest extends Request<UpdateLinkedTasksParams, IEmptyResult> {
  constructor(params: UpdateLinkedTasksParams) {
    super('updateLinkedTasksSchedule', params);
  }
}
